import React, { useLayoutEffect } from 'react';
import Auth from './components/pages/auth';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import Snackbars from './components/atoms/snackbar';
import SecondarySnackbar from './components/atoms/snackbar/SecondarySnackBar';
import MultiLineSnackbar from './components/atoms/snackbar/MultiLineSnackbar';
import TopRightInfo from './components/atoms/snackbar/TopRightInfo';
import { useSelector, useDispatch } from 'react-redux';
import { getLoginStatus, getPageLoaderStatus } from './store/auth/selectors';
import {authCheck, togglePageLoader} from '../src/store/auth/actions';
import FullPageLoader from './components/atoms/fullPageLoader';
import ErrorBoundary from './components/atoms/errorBoundary';


const AuthHoc = (WrappedComponent) => {
  const Wrapper = () => {
    const dispatch = useDispatch();
    useLayoutEffect(() => {
      let url = window.location;
      if(url?.pathname !== '/verify-email') {
        dispatch(authCheck());
      } else {
        dispatch(togglePageLoader());
      }
    }, []);

    const isLoggedIn = useSelector(getLoginStatus);

    const togglerLoaderValue = useSelector(getPageLoaderStatus);

    let component = (
      <ErrorBoundary>
        <WrappedComponent />
      </ErrorBoundary>
    );

    if (togglerLoaderValue) component = <FullPageLoader open={togglerLoaderValue} />;
    else if (!isLoggedIn) component = <Auth />;

    return (
      <React.Fragment>
        <BrowserRouter>
          <MuiThemeProvider theme={theme}>
            {component}
            <Snackbars />
            <TopRightInfo />
            <SecondarySnackbar />
            <MultiLineSnackbar />
          </MuiThemeProvider>
        </BrowserRouter>
      </React.Fragment>
    );
  };

  return Wrapper;
};

export default AuthHoc;
/*


const snackbar = useSelector((store) =>{
return store.global.snackbar
})


*/
